module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/upset-working-woman-1-2564057d0d596c7b8084709555509464.jpeg";